(function () {
 if (window.umDiaEnquiryReady) return;
 window.umDiaEnquiryReady = true;
 function syncGift(form) {
  var check = form.querySelector('#UdGift'), group = form.querySelector('.ud-gift-details');
  if (!check || !group) return;
  var prices = form.querySelector('#UdService').value === 'Formatos e preços';
  group.hidden = prices || !check.checked;
  group.querySelectorAll('input').forEach(function (input) { input.disabled = group.hidden; });
 }
 function syncForm(form) {
  var select = form.querySelector('#UdService'); if (!select) return;
  var prices = select.value === 'Formatos e preços';
  form.querySelectorAll('.ud-purpose,.ud-moment-field,.ud-form-extra').forEach(function(group){
   group.hidden = prices;
   group.querySelectorAll('input,textarea,select,button').forEach(function(input){input.disabled=prices;});
  });
  var note=form.querySelector('.ud-prices-form-note');if(note)note.hidden=!prices;
  var interest=form.querySelector('[data-ud-price-interest]');if(interest)interest.disabled=!prices;
  var button=form.querySelector('button[type=submit]'),label=form.querySelector('[data-ud-submit-label]');
  if(button&&label)label.textContent=prices?button.dataset.udPriceLabel:button.dataset.udDefaultLabel;
  syncGift(form);
 }
 document.addEventListener('change', function (event) {
  if (event.target.matches('#UdGift, #UdForSelf')) syncGift(event.target.closest('form'));
  if (event.target.matches('#UdService')) {
   var form=event.target.closest('form'),interest=form.querySelector('[data-ud-price-interest]');
   if(interest)interest.value='Filmes e fotografia';syncForm(form);
  }
 });
 document.addEventListener('click', function (event) {
  var idea = event.target.closest('[data-ud-idea]');
  if (idea) {
   var area = idea.closest('form').querySelector('#UdMoment'),text = idea.dataset.udIdea;
   if (!area.value.includes(text)) area.value += (area.value.trim() ? '\n' : '') + text;
   area.focus();area.dispatchEvent(new Event('input',{bubbles:true}));
  }
  var link = event.target.closest('[data-ud-enquiry]');
  if (link) {
   var form = document.querySelector('#UmDiaContact'); if (!form) return;
   var select=form.querySelector('#UdService'),gift=form.querySelector('#UdGift'),interest=form.querySelector('[data-ud-price-interest]');
   if (link.dataset.udEnquiry === 'film' && select) select.value='Filme documental';
   if (link.dataset.udEnquiry === 'photo' && select) select.value='Sessão de fotografia documental';
   if (link.dataset.udEnquiry === 'prices' && select) {select.value='Formatos e preços';if(interest)interest.value=link.dataset.udPriceService||'Filmes e fotografia';}
   if (link.dataset.udEnquiry === 'gift' && gift) {gift.checked=true;if(select&&select.value==='Formatos e preços')select.value='Ainda não sei';}
   syncForm(form);
  }
 });
 function init(scope) {
  scope.querySelectorAll('.ud-enquiry-form').forEach(syncForm);
  var notice=scope.querySelector('.ud-form-notice,.ud-form-errors');
  if(notice){notice.scrollIntoView({block:'center'});notice.setAttribute('tabindex','-1');notice.focus({preventScroll:true});}
 }
 init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
